













import { Component, Vue, Model } from "vue-property-decorator";

@Component
class SoloInput extends Vue {
  @Model("input") value;

  handleInput(val) {
    this.$emit("input", val);
  }
}
export default SoloInput;
